import { modal as modalJS } from '../../modal/ModalEmitter';

interface IModal {
  confirm: (args: {
    callback: () => void;
    confirmLabels?: string[];
    message: string;
    onClose?: () => void;
    title: string;
  }) => void;
  close: () => void;
  open: (type: string, args: {}) => void;
}

const modal: IModal = modalJS as any;
export default modal;
